import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';
import { ClickOutsideModule } from 'ng4-click-outside';
/*import { DashboardComponent } from './dashboard/dashboard.component';

import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { AddUserComponent } from './user/add-user/add-user.component';*/

import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
//import {MatRippleModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
//import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';

import {
  AgmCoreModule
} from '@agm/core';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
//import { UserAddComponent } from './user-profile/user-add/user-add.component';
import { LoginComponent } from './login/login.component';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { AngularMaterialModule } from './lib/angular-material.module';
import { MatDialogModule } from '@angular/material/dialog';
//import { DashboardComponent } from './site/dashboard/dashboard.component';
//import { NewsComponent } from './site/news/news.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharednewsComponent } from './sharednews/sharednews.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxPrintModule } from 'ngx-print';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';

export function tokenGetter() {
  return '';
}

@NgModule({
  // entryComponents:[MatConfirmDialogComponent],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    AngularMaterialModule,
    MatDialogModule,
    Ng2SearchPipeModule,
    HighchartsChartModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'GOOGLE_MAPS_API_KEY'
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        //allowedDomains: ["example.com"],
        //disallowedRoutes: ["http://example.com/examplebadroute/"],
      },
    }),
    MatButtonModule,
    //MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    //MatTooltipModule,
    NgxPrintModule,
    ClickOutsideModule,
    ChartsModule
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    SiteLayoutComponent,
    //UserAddComponent,
    LoginComponent,
    SharednewsComponent,
    //DashboardComponent,
    //NewsComponent,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
